module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_8023.58cf3d26.png";